import mainApi from "../../api/mainApi";
import { CatalogsResponse } from "../../interfaces/catalogs/catalogs.interface";
import { middlewareApi } from "../../middlewares/middlewareApi";

const catalogsService = middlewareApi.injectEndpoints({
  endpoints: (builder) => ({
    /**
     * @GET
     */
    getCatalogos: builder.query<
      CatalogsResponse,
      {
        page: number;
        size: number;
        type: string;
      }
    >({
      queryFn: async ({ page, size, type }) => {
        try {
          const { data } = await mainApi.get("catalogos", {
            params: {
              page,
              size,
              type,
            },
          });
          return { data };
        } catch (error: any) {
          return { error: error };
        }
      },
    }),
  }),
});

export const { useGetCatalogosQuery } = catalogsService;
